<script setup>
import { defineAsyncComponent,ref } from 'vue';

import { useStore } from 'vuex';

const store = useStore();

const componentType = store.getters.componentType;

if (!componentType) {
  console.log('Component type is not defined in the store');
}

const dynamicComponent = loadComponent(componentType);
const currentProperties = ref(store.state.data.paragraaf[0]);

function loadComponent(name) {
  try {
    const formattedName = name.split('.')[1];
    console.log(formattedName);
    return defineAsyncComponent(() => import(`./paragrafen/${formattedName}/index.vue`));
  } catch (error) {
    console.log('Error loading component:', error);
    return null;
  }
}
</script>

<template>
  <div 
    class="knd-component-wrapper"
    :class="store.state.data.customClass"
    :style="['--bg-story: ' + store.state.data.bgStory]"
  >
    <dynamicComponent 
      v-bind="{...currentProperties}" 
    />
  </div>
</template>

<style lang="scss" scoped>
  .knd-component-wrapper {
    background-color: var(--bg-story, #FFF);
  }

</style>